import { useEffect } from 'react';

/**
 * Meta Pixel base code. Every pixel in PIXEL_IDS is initialized once,
 * and a single PageView call per page load reaches all of them.
 */
const PIXEL_IDS = ['2700042880457167', '2685026745295914'];
type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: Fbq;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
    __metaPixelInitialized?: boolean;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || PIXEL_IDS.length === 0) return;
    // Guard against double init (re-renders, React StrictMode, hot reloads).
    if (window.__metaPixelInitialized) return;
    window.__metaPixelInitialized = true;
    if (!window.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) fbq.callMethod(...args);else fbq.queue.push(args);
      } as Fbq;
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      window.fbq = fbq;
      if (!window._fbq) window._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    const fbq = window.fbq;
    if (!fbq) return;
    PIXEL_IDS.forEach(id => fbq('init', id));
    fbq('track', 'PageView');
  }, []);
  return null;
}